import { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Loader2, Wand2, FileText, Languages, ListTodo, PenLine } from "lucide-react";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

const ACTIONS = [["improve", "تحسين الصياغة", Wand2], ["summarize", "تلخيص", FileText], ["tasks", "استخراج مهام", ListTodo], ["translate_en", "ترجمة للإنجليزية", Languages], ["translate_ar", "ترجمة للعربية", Languages]];

// AI bar: works on selected blocks (or the whole page) and appends/replaces the result.
export const WsAiBar = ({ blocks, selected, onResult }) => {
  const [prompt, setPrompt] = useState("");
  const [busy, setBusy] = useState("");
  const pick = selected?.size ? blocks.filter((b) => selected.has(b.id)) : blocks;
  const src = pick.map((b) => b.text).filter(Boolean).join("\n");
  const typed = pick.filter((b) => b.text).map((b) => `[${b.type}${b.type === "todo" && b.checked ? ":done" : ""}] ${b.text}`).join("\n");
  const run = async (action) => {
    setBusy(action);
    try {
      const keep = action === "improve" || action.startsWith("translate");
      const r = await api.wsAi({ action, text: action === "write" ? "" : keep ? typed : src, prompt });
      onResult(r.blocks, action === "improve" || action.startsWith("translate") ? "replace" : "append");
      setPrompt(""); toast.success("تمت إضافة المحتوى");
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر التنفيذ"); } finally { setBusy(""); }
  };
  return (
    <div className="rounded-2xl border border-violet-200 bg-violet-50/60 p-3" data-testid="ws-ai-bar">
      <div className="flex gap-2">
        <div className="relative flex-1"><Sparkles className="absolute right-3 top-2.5 h-4 w-4 text-violet-500" />
          <Input value={prompt} onChange={(e) => setPrompt(e.target.value)} onKeyDown={(e) => e.key === "Enter" && prompt.trim() && run("write")}
            placeholder="اطلب من المساعد: اكتب سياسة إجازات… خطة تسويق… رسالة للعملاء" className="border-violet-200 bg-white pr-9" data-testid="ws-ai-prompt" /></div>
        <Button onClick={() => run("write")} disabled={!!busy || !prompt.trim()} className="gap-1 bg-violet-600 hover:bg-violet-700" data-testid="ws-ai-write">
          {busy === "write" ? <Loader2 className="h-4 w-4 animate-spin" /> : <PenLine className="h-4 w-4" />} اكتب</Button>
      </div>
      <div className="mt-2 flex flex-wrap items-center gap-1.5">
        <span className="text-[11px] text-violet-800/80">{selected?.size ? `على ${selected.size} كتلة محددة:` : "على كامل الصفحة:"}</span>
        {ACTIONS.map(([k, l, Icon]) => (
          <button key={k} onClick={() => run(k)} disabled={!!busy || !src} data-testid={`ws-ai-${k}`}
            className="inline-flex items-center gap-1 rounded-full border border-violet-200 bg-white px-2.5 py-1 text-[11px] text-violet-800 transition-colors hover:bg-violet-100 disabled:opacity-40">
            {busy === k ? <Loader2 className="h-3 w-3 animate-spin" /> : <Icon className="h-3 w-3" />}{l}</button>))}
      </div>
    </div>
  );
};
